import Header from '../component/Header'

const Now = ()=>{
    return <div style={{height:'100vh',backgroundColor:'white',padding:10}}>
{/* Header */}
<Header dark/>


<h1>Now</h1>
    </div>
  }
  
  export default Now